{
  "Home": "Додому",
  "My library": "Бібліотека",
  "loading": "Завантаження",
  "Log in": "Вхід",
  "Sign up": "Реєстрація",
  "OR": "АБО",
  "Filmoteka": "Фільмотека",
  "Watched": "Переглянуто",
  "Queue": "Черга",
  "Developed with": "Розроблено",
  "by": ".",
  "GoIT Students": "Студентами GoIT",
  "Team": "Команда",
  "'IT-bees'": "'IT-бджілки'",
  "Oleg Bilas": "Олег Білас",
  "Team-lead": "Тім-лід",
  "Inna Shavarovska": "Інна Шаваровська",
  "Scrum-master": "Скрам-майстер",
  "Oleksandr Samarskyi": "Олександр Самарський",
  "Developer": "Розробник",
  "Shadi Abumutair": "Шаді Абумутаір",
  "Vika Rabotilova": "Віка Работілова",
  "Vlad Shostak": "Владислав Шостак",
  "Yevhen Chaban": "Євген Чабан",
  "Viktor Dubrovets": "Віктор Дубровець",
  "Nataliia Rumiantseva": "Наталія Румянцева",
  "Ivan Tishchenko": "Іван Тищенко",
  "Vote / Votes": "Голос / Голосів",
  "Popularity": "Популярність",
  "Original Title": "Оригінальна назва",
  "Genre": "Жанр",
  "About": "Опис"
}
